import { render, staticRenderFns } from "./DeptRoleAuthModal.vue?vue&type=template&id=c519f984&scoped=true"
import script from "./DeptRoleAuthModal.vue?vue&type=script&lang=js"
export * from "./DeptRoleAuthModal.vue?vue&type=script&lang=js"
import style0 from "./DeptRoleAuthModal.vue?vue&type=style&index=0&id=c519f984&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c519f984",
  null
  
)

export default component.exports